import * as z from "zod";

export const updateReturnWithWaivedCustomerCompensation = {
  name: "updateReturnWithWaivedCustomerCompensation" as const,
  input: z.object({ id: z.string(), waivedCustomerCompensation: z.boolean() }),
  output: z.object({ success: z.boolean() }),
};
